// Module
var code = "<label class=\"ohnohoney\" for=\"name\"></label> <input class=\"ohnohoney\" autocomplete=\"off\" type=\"text\" name=\"name\" placeholder=\"Your name here\" ng-model=\"$ctrl.userName\" ng-change=\"$ctrl.onNameChange({ userName: $ctrl.userName })\"/>";
// Exports
module.exports = code;